import { render, staticRenderFns } from "./AdsChart.vue?vue&type=template&id=70b80e36&"
import script from "./AdsChart.vue?vue&type=script&lang=js&"
export * from "./AdsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports